"use client";

import { getCohesionConfigForPathname } from "@/constants/cohesion-config";
import { CohesionSnippet } from "@redventures/cohesion-utils-react";
import { usePathname } from "next/navigation";
import React from "react";
import type { CohesionSnippetByRouteProps } from "./types";

/**
 * Loads Cohesion with route-scoped Fuse config. Social LPs disable Fuse leases;
 * BAU keeps the default pool lease behavior. The server supplies the base
 * config so SSR and client hydration serialize the same environment values.
 */
const CohesionSnippetByRoute: React.FC<CohesionSnippetByRouteProps> = ({
  baseConfig,
  src,
}) => {
  const pathname = usePathname();
  const config = getCohesionConfigForPathname(pathname, baseConfig);

  return <CohesionSnippet config={config} src={src} />;
};

export default CohesionSnippetByRoute;
